import { BaseController } from '@/api/BaseController';
import { RequestOption } from '@/common/http/types';
import { ANY_OBJECT } from '@/types/generic';
import { TableData } from '@/common/types/table';
import { useUrlBuilder } from '@/common/hooks/useUrl';
import Vacation from '@/types/table/vacation';
import { API_CONTEXT } from '../config';

const { buildGetUrl } = useUrlBuilder();

export interface VacationData extends Vacation {
  __cascade_add_temp_id__?: string | number | undefined;
}

export default class VacationController extends BaseController {
  static list(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post<TableData<VacationData>>(API_CONTEXT + '/upms/vacation/list', params, httpOptions);
  }
  static view(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.get<VacationData>(API_CONTEXT + '/upms/vacation/view', params, httpOptions);
  }
  static export(params: ANY_OBJECT, fileName: string) {
    return super.download(API_CONTEXT + '/upms/vacation/export', params, fileName);
  }
  static import(params: ANY_OBJECT) {
    return super.upload(API_CONTEXT + '/upms/vacation/import', params);
  }
  static printUrl(params: ANY_OBJECT) {
    return buildGetUrl(API_CONTEXT + '/upms/vacation/print', params);
  }
  static add(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/upms/vacation/add', params, httpOptions);
  }
  static update(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/upms/vacation/update', params, httpOptions);
  }
  static delete(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/upms/vacation/delete', params, httpOptions);
  }
  static deleteBatch(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/upms/vacation/deleteBatch', params, httpOptions);
  }
  static startOnlyVacationApply(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/upms/vacation/startOnly/vacationApply', params, httpOptions);
  }
  static startWithBusinessKeyVacationApply(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/upms/vacation/startWithBusinessKey/vacationApply', params, httpOptions);
  }
  static startAndTakeUserTaskVacationApply(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/upms/vacation/startAndTakeUserTask/vacationApply', params, httpOptions);
  }
  static startAndSaveDraftVacationApply(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/upms/vacation/startAndSaveDraft/vacationApply', params, httpOptions);
  }
  static submitUserTaskVacationApply(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/upms/vacation/submitUserTask/vacationApply', params, httpOptions);
  }
  static viewTaskBusinessDataVacationApply(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.get(API_CONTEXT + '/upms/vacation/viewTaskBusinessData/vacationApply', params, httpOptions);
  }
  static viewHistoricTaskBusinessDataVacationApply(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.get(API_CONTEXT + '/upms/vacation/viewHistoricTaskBusinessData/vacationApply', params, httpOptions);
  }
  static listWorkOrderVacationApply(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/upms/vacation/listWorkOrder/vacationApply', params, httpOptions);
  }
}
